// Shown across the top of every screen while an operator is viewing a tenant.
//
// It lives in AppShell rather than Topbar for two reasons: 56px of fixed
// topbar geometry is the wrong place for an unmissable persistent warning, and
// it must not read as a page action. AppShell mounts once (that is the whole
// point of the pathless layout route), so this survives every navigation with
// no context and no portal.
//
// Not a `ui/` primitive: one caller, and `ui/index.test.tsx` would demand a
// FIXTURES entry and a no-hex sweep for what is shell chrome. It inherits
// `data-chassis="paper"` from the AppShell root above it, which is exactly why
// it must not be rendered anywhere else.

import { Button } from "../ui";
import { useMe } from "../screens/overview/api";
import { stopImpersonating } from "../screens/admin/api";

export function ImpersonationBanner() {
  const me = useMe();
  if (me.data?.impersonating !== true) return null;

  return (
    <div className="maisight-shell-impersonating" role="status">
      <span className="maisight-shell-impersonating-text type-bodyS">
        {/* Truthful about attribution. Do NOT soften this to "read only" — the
            session is a real session and every write lands under this email. */}
        Viewing <strong>{me.data.org_slug}</strong> as {me.data.email}. Anything
        you change here is recorded against your account.
      </span>
      <Button variant="secondary" size="sm" onClick={stopImpersonating}>
        Stop viewing
      </Button>
    </div>
  );
}
